<template>
  <Dialog
    v-model:visible="showModalRef"
    :close-on-escape="false"
    :dismissableMask="false"
    :modal="store.getters.dialogsModal"
  >
    <template #header>
      Seleccione el rol para visualizar el informe
      <i
        class="custom-close-dialog-button cursor-pointer p-2 pi pi-times"
        @click="goBack()"
      ></i>
    </template>

    <div class="col-12">
      <div class="flex flex-column gap-3">
        <div
          v-for="(rol, index) in roles"
          :key="index"
          class="flex align-items-center"
        >
          <Checkbox
            v-model="selectedRoles"
            :inputId="`rol-${index}`"
            :value="rol.nombre"
          />
          <label :for="`rol-${index}`" class="ml-2"> {{ rol.nombre }} </label>
        </div>
        <div v-if="error" class="p-error">{{ error }}</div>
      </div>
    </div>

    <template #footer>
      <div class="col-12">
        <div class="flex justify-content-between flex-wrap gap-3">
          <Button label="Volver" severity="secondary" @click="goBack" />
          <Button
            label="Aceptar"
            @click="accept()"
            :loading="loading"
            loading-icon="pi pi-spinner"
          />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import Dialog from "primevue/dialog";
import Checkbox from "primevue/checkbox";
import Button from "primevue/button";
import { useToast } from "primevue/usetoast";
import { useStore } from "vuex";

// #region Props, Emits
const emit = defineEmits(["handle-close"]);
// #endregion

// #region Params, Ref, Reactives, Computed
const loading = ref(false);
const store = useStore();
const showModalRef = ref(false);
const roles = ref([]);
const selectedRoles = ref([]);
const router = useRouter();
const error = ref(null);
const toast = useToast();
// #endregion

// #region Functions
// Open the modal with the data
function showModal(data) {
  roles.value = data;

  if (roles.value.length == 0) {
    toast.add({
      severity: "info",
      summary: "No tiene roles asociados",
      detail: `No puede acceder al informe porque no tiene roles asociados al informe`,
      life: 3000,
    });

    goBack();
  }

  roles.value = roles.value.map((role) => ({
    nombre: role,
  }));

  // Show the modal
  showModalRef.value = true;

  selectedRoles.value = [roles.value[0].nombre];
}

function accept() {
  if (selectedRoles.value === null || selectedRoles.value.length === 0) {
    error.value = "Debe seleccionar al menos un rol";
    return;
  }

  loading.value = true;

  emit("handle-close", selectedRoles.value);
}

function goBack() {
  closeModal();

  router.push({
    name: "Public reports",
  });
}

function closeModal() {
  showModalRef.value = false;
}
// #endregion

// #region Effects, Hooks
// Watch for the selected roles
watch(selectedRoles, () => {
  error.value = null;
});
// #endregion

// #region Provide, Expose
defineExpose({
  showModal,
  closeModal,
  loading,
});
// #endregion
</script>
